import { useStore } from "stores/store";
import { useOrganization } from "./organization";
import { AllLocales } from "models/locale";

export const useLocale = () => {
  const locale = useStore((state) => state.locale);
  return locale;
};

export const useLocales = () => {
  const organization = useOrganization();
  if (organization && organization.locales) {
    return organization.locales;
  }
  return AllLocales;
};
